import { Logger, ensureEndingSlash, isModuleAvailable } from "@vuepress/helper";
import { colors, getDirname, path } from "vuepress/utils";

const __dirname = getDirname(import.meta.url);

export const PLUGIN_NAME = "vuepress-plugin-md-enhance";

export const logger = new Logger(PLUGIN_NAME);

export const CLIENT_FOLDER = ensureEndingSlash(path.resolve(__dirname, "../client"));

export const isInstalled = (pkg: string, hint = true): boolean => {
  const isAvailable = isModuleAvailable(pkg, import.meta);

  if (hint && !isAvailable)
    logger.error(`Package ${colors.cyan(pkg)} is not installed, please install it manually!`);

  return isAvailable;
};
